import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LiveTab from "./pages/LiveTab";
import HistoricalTab from "./pages/HistoricalTab";
import InfoTab from "./pages/InfoTab";
import Login from "./pages/Login";
import CustomizationTab from "./pages/CustomizationTab";
import NotificationsPage from "./pages/NotificationsPage";
import BillReconciliationTab from "./pages/BillReconciliationTab";
import OffGridCalculatorTab from "./pages/OffGridCalculatorTab";
import ComplaintTicketTab from "./pages/ComplaintTicketTab";
import EnvironmentTab from "./pages/EnvironmentTab";
import EfficiencyInitiativesTab from "./pages/EfficiencyInitiativesTab";
import Chatbot from "./pages/Chatbot";
import EnSightTab from "./components/InSight/InSightTab";
import PrivateRoute from "./components/PrivateRoute";
import LandingRedirect from "./components/LandingRedirect";

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public route */}
      <Route path="/login" element={<Login />} />

      {/* Root goes to the first tab enabled for the user */}
      <Route path="/" element={<LandingRedirect />} />

      {/* Private routes */}
      <Route
        path="/live"
        element={
          <PrivateRoute>
            <LiveTab />
          </PrivateRoute>
        }
      />
      <Route
        path="/historical"
        element={
          <PrivateRoute>
            <HistoricalTab />
          </PrivateRoute>
        }
      />
      <Route
        path="/historical/insights"
        element={<Navigate to="/ensight" replace />}
      />
      <Route
        path="/info"
        element={
          <PrivateRoute>
            <InfoTab />
          </PrivateRoute>
        }
      />
      <Route
        path="/customization"
        element={
          <PrivateRoute>
            <CustomizationTab />
          </PrivateRoute>
        }
      />
      <Route
        path="/notifications"
        element={
          <PrivateRoute>
            <NotificationsPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/bill-reconciliation"
        element={
          <PrivateRoute>
            <BillReconciliationTab />
          </PrivateRoute>
        }
      />
      <Route
        path="/tools/off-grid-calculator"
        element={
          <PrivateRoute>
            <OffGridCalculatorTab />
          </PrivateRoute>
        }
      />
      <Route
        path="/tools/complaint-ticket"
        element={
          <PrivateRoute>
            <ComplaintTicketTab />
          </PrivateRoute>
        }
      />
      <Route
        path="/tools/efficiency-initiatives"
        element={
          <PrivateRoute>
            <EfficiencyInitiativesTab />
          </PrivateRoute>
        }
      />
      <Route
        path="/tools/environment"
        element={
          <PrivateRoute>
            <EnvironmentTab />
          </PrivateRoute>
        }
      />
      <Route
        path="/tools/environment/efficiency"
        element={
          <PrivateRoute>
            <EnvironmentTab />
          </PrivateRoute>
        }
      />
      <Route
        path="/tools/environment/historical"
        element={
          <PrivateRoute>
            <EnvironmentTab />
          </PrivateRoute>
        }
      />
      <Route
        path="/tools/chatbot"
        element={
          <PrivateRoute>
            <Chatbot />
          </PrivateRoute>
        }
      />
      <Route
        path="/chatbot"
        element={
          <PrivateRoute>
            <Chatbot />
          </PrivateRoute>
        }
      />
      <Route
        path="/ensight"
        element={
          <PrivateRoute>
            <EnSightTab />
          </PrivateRoute>
        }
      />

      {/* Catch all unknown routes and redirect to login */}
      <Route path="*" element={<Login />} />
    </Routes>
  );
};

export default AppRoutes;
